module.exports = "<div>\n    <md-toolbar color=\"primary\">\n      <div class=\"sws-toolbar\">\n        <div>\n          <h3>(c) 2017 Sowentus Software Engineering, Eppingen</h3>\n        </div>\n      </div>  \n    </md-toolbar>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// D:/Crossplatform/swsLagerinfo/src/app/infofooter/infofooter.component.html
// module id = ../../../../../src/app/infofooter/infofooter.component.html
// module chunks = 1